import { useQueryClient } from '@tanstack/react-query';
import useMoney from '../../../hooks/useMoney';
import { getValidateOrderProductsKey } from '../../../services/modules/order-product/order-product.keys';
import { ValidateOrderProductsOutput } from '../../../services/modules/order-product/order-product.types';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../translation/TranslationContext';
import { useOrderEditSectionsContext } from '../edit/sections/OrderEditSections.context';
import {
  getBusinessPolicyViolationViews,
  indexViolationsByItem,
} from '../edit/validate/conditions/businessPolicy/businessPolicyViolation.utils';
import { getPendingOrderProductKeys } from '../products/helpers/orderProductsPendency.utils';

const usePendingOrderProductKeys = (orderId: string) => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();
  const { orderProductsWithErrors, productsBusinessPolicyViolationsByItem } =
    useOrderEditSectionsContext();

  const pendingOrderProductKeys = getPendingOrderProductKeys({
    orderProductsWithErrors,
    policyViolationsByItem: productsBusinessPolicyViolationsByItem,
  });

  const getLatestPendingOrderProductKeys = () => {
    const validation = queryClient.getQueryData<ValidateOrderProductsOutput | null>([
      team?.id,
      ...getValidateOrderProductsKey({ orderId }),
    ]);

    if (!validation?.orderProductsWithErrors) {
      return pendingOrderProductKeys;
    }

    const policyViolations = getBusinessPolicyViolationViews({
      errors: validation.businessPolicyErrors ? [validation.businessPolicyErrors] : [],
      translate,
      formatMoney,
    });

    return getPendingOrderProductKeys({
      orderProductsWithErrors: validation.orderProductsWithErrors,
      policyViolationsByItem: indexViolationsByItem(policyViolations),
    });
  };

  return { pendingOrderProductKeys, getLatestPendingOrderProductKeys };
};

export default usePendingOrderProductKeys;
